import { Api, BuildVersion, COUNTRY_CODE } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { postMethod } from "../post";

export const api_LoadMobileSalesOrder = () => {
  var url = `${Api}/?ControllerName104=/ApiOrder`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadMobileSalesOrder","CSID":' +
      dto_Customer.CSID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};

export const api_OpenSalesOrderForCustomerMobileApp = (GUID) => {
  var url = `${Api}/?ControllerName104=/ApiOrder`;
  return postMethod(
    url,
    '{"SERVICENAME":"OpenSalesOrderForCustomerMobileApp","GUID":' +
      GUID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_SubmitRatings = (ratingObj, GUID) => {
  var url = `${Api}/?ControllerName104=/ApiOrder`;
  return postMethod(
    url,
    '{"SERVICENAME":"SubmitRatingsForInvoice","ratingObj":' +
      JSON.stringify(ratingObj) +
      ', "GUID" : ' +
      GUID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_UpdateSkipRatings = (GUID) => {
  var url = `${Api}/?ControllerName104=/ApiOrder`;
  return postMethod(
    url,
    '{"SERVICENAME":"SkipRatingsForInvoice", "GUID" : ' +
      GUID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_CancelSalesOrderByCustomer = (GUID) => {
  var url = `${Api}/?ControllerName104=/ApiOrder`;
  return postMethod(
    url,
    '{"SERVICENAME":"CancelSalesOrderByCustomer","GUID":' +
      GUID +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"STATUS":2,"COUNTRYCODE":"' +
      COUNTRY_CODE +
      '"}',
  );
};
